import {Component, Input, OnInit} from '@angular/core';
import {NgForOf, NgIf, NgStyle} from "@angular/common";
import _default from "chart.js/dist/plugins/plugin.tooltip";
import {Router} from "@angular/router";
import {GlobalService} from "../../../services/global.service";
import {ConfigService} from "../../../services/config.service";

@Component({
    selector: 'app-bottom-slider',
    standalone: true,
    imports: [
        NgStyle,
        NgForOf,
        NgIf
    ],
    templateUrl: './bottom-slider.component.html',
    styleUrl: './bottom-slider.component.css'
})
export class BottomSliderComponent implements OnInit {
    @Input() logoType:number=2;
    @Input() opacity:boolean = true;
    tempLogos=[];
    wLogos = [
        "aparat_w.svg",
        "banimod_w.svg",
        "digijet_w.svg",
        "doctorSaina_w.svg",
        "doctorto_w.svg",
        "fidibo_w.svg",
        "filimo_w.svg",
        "filmnet_w.svg",
        "banimod_w.svg",
        "gooshishop_w.svg",
        "Khanoumi_w.svg",
        "namava_w.svg",
        "okala_w.svg",
        "paziresh24_w.svg",
        "pindo_w.svg",
        "roja_w.svg",
        "shaypoor_w.svg",
        "sibapp_w.svg",
        "snapp_w.svg",
        "taghcha_w.svg"
    ]
    cLogos = [
        "aparat.svg",
        "banimod.svg",
        "digijet.svg",
        "doctorSaina.svg",
        "doctorto.svg",
        "fidibo.svg",
        "filimo.svg",
        "filmnet.svg",
        "banimod.svg",
        "gooshishop.svg",
        "Khanoumi.svg",
        "namava.svg",
        "okala.svg",
        "paziresh24.svg",
        "pindo.svg",
        "roja.svg",
        "shaypoor.svg",
        "sibapp.svg",
        "snapp.svg",
        "taghcha.svg"
    ]
    constructor( public route: Router,
                 public global: GlobalService,
                 protected config: ConfigService){

    }
    ngOnInit(): void {
            this.wLogos = this.global.getMainData()['main-page'] != null ? JSON.parse(this.global.getMainData()['main-page']['data'])['business-bar'] :'';
            setTimeout(()=>{
                this.wLogos = this.global.getMainData()['main-page'] != null ? JSON.parse(this.global.getMainData()['main-page']['data'])['business-bar']:'';
            },1000)
            this.tempLogos = this.wLogos;
    }

}
